import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import HouseholdPointsList from './components/HouseholdPointsList';

const { Cell } = ResponsiveGrid;

const HouseholdPoints = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="每戶點數變動紀錄"
        // description="公告事項"
        breadcrumbs={[
          {
            name: '社區管理',
          },
          {
            name: '每戶點數變動紀錄',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <HouseholdPointsList />
    </Cell>
  </ResponsiveGrid>
);

export default HouseholdPoints;
